
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import "@/store/modules/common";
const commonState = namespace("Common");

import Form4ProcessHeader from "@/components/process/Form4/components/Form4ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form4DataInfoType, form4StatusInfoType } from '@/types/Information/Form4';
import { packageInfoType } from '@/types/Information';

import { GetForm4PdfType } from "./components/Form4PdfType"
import { documentTypesJsonInfoType } from '@/types/Common';

@Component({
    components:{
        Form4ProcessHeader,
        Spinner
    }
})
export default class SubmitForm4 extends Vue {

    @form4State.State
    public currentNoticeOfApplicationId: string;

    @form4State.State
    public form4Info: form4DataInfoType;

    @form4State.State
    public supportingDocuments!: any;

    @form4State.Action
    public UpdateSupportingDocuments!: (newSupportingDocuments) => void

    @commonState.State
    public documentTypesJson: documentTypesJsonInfoType[]

    stepsCompleted = {} as form4StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    supportingFile = null;
    showTypeOfDocuments = false;
    fileType = "";
    selectedDocumentTypeState = true;
    supportingDocumentFields = [
        { key: 'fileName', label: 'File Name',tdClass:'align-middle'},
        { key: 'fileType', label: 'File Type',tdClass:'align-middle'},
        { key: 'edit', thClass: 'd-none',tdClass:'align-middle'},
        { key: 'preview', thClass: 'd-none'}
    ];

    mounted() {
        this.mountedData = false;   
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;      
        
        Vue.nextTick(()=>{
            const dropArea = document.getElementById('drop-area');
            dropArea.addEventListener('drop', this.handleFileDrop, false);
            dropArea.addEventListener('dragenter', this.dragPreventDefaults, false);
            dropArea.addEventListener('dragleave', this.dragPreventDefaults, false);
            dropArea.addEventListener('dragover', this.dragPreventDefaults, false);     
        })
    }  

    public submit() {
        
        this.errorMsg =""
        const bodyFormData = new FormData();
        const docType = []
        const lastFileTypes = this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:[]
        
        let fileIndex = 0;
        for(const filetype of lastFileTypes){
        
            const tempSupportingDocs = this.supportingDocuments?.filter(doc=>{return(doc.documentType==filetype)})
        
            if(tempSupportingDocs.length>0){
                const filesIndices = [];
                const filesRotation = [];
                for(const supportingDoc of tempSupportingDocs){
                    bodyFormData.append('files',supportingDoc['file']);
                    filesIndices.push(fileIndex)
                    filesRotation.push(supportingDoc['imageRotation'])
                    fileIndex++;
                }
                docType.push({type: tempSupportingDocs[0]['documentType'], files: filesIndices, rotations:filesRotation})
            }
        }
        
        const docTypeJson = JSON.stringify(docType);
        bodyFormData.append('documents', docTypeJson);          
        
        this.submitting = true;

        const url = "/form4/efiling/"+this.currentNoticeOfApplicationId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "multipart/form-data",
                Accept: "application/json"                  
            }
        }

        bodyFormData.append('document_type', GetForm4PdfType(this.form4Info)); //"MCH"

        this.$http.post(url, bodyFormData, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }

    public dragPreventDefaults (e) {
        e.preventDefault()
        e.stopPropagation()
    }

    public handleFileDrop(e) {
        e.preventDefault()
        e.stopPropagation()
        const dt = e.dataTransfer
        const files = dt.files

        if (files && files[0]) 
        {
            this.supportingFile = files;            
            this.showTypeOfDocuments= true;
        }
    } 

    public uploadClicked(){
        const el = document.getElementById("inputfile");
        if(el) el.click();
    }

    public handleSelectedFile(event){

        event.preventDefault();
        event.stopPropagation();
        
        if (event.target.files && event.target.files[0]) 
        {
            this.supportingFile = event.target.files;
            this.showTypeOfDocuments= true;
        }
    }

    public addDocument() {
        this.selectedDocumentTypeState = this.fileType.length>0? true: false;

        if (this.supportingFile && this.fileType.length>0) {

            this.showTypeOfDocuments = false;

            const supportingdocuments = this.supportingDocuments 
            let typeIndex =  this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:[]
            if(!typeIndex.includes(this.fileType))
                typeIndex.push(this.fileType)
            
            for(const supportingfile of this.supportingFile){
            
                const newFile = {
                    "fileName": supportingfile.name,
                    "file": supportingfile,
                    "documentType": this.fileType,
                    "image": URL.createObjectURL(supportingfile),
                    "imageRotation": 0,
                    "typeIndex":typeIndex
                }
                supportingdocuments.push(newFile);
            }

            this.UpdateSupportingDocuments(supportingdocuments);
            this.supportingFile = null;
            this.fileType = "";
            Vue.nextTick(()=>{
                const el = document.getElementById('drop-area');
                if(el) el.scrollIntoView();
            })
        }
    }

    public removeDocument(index) {
        this.supportingDocuments.splice(index, 1);
    }
}
